import { render, staticRenderFns } from "./IndexLhu.vue?vue&type=template&id=9f349848&scoped=true&"
import script from "./IndexLhu.vue?vue&type=script&lang=js&"
export * from "./IndexLhu.vue?vue&type=script&lang=js&"
import style0 from "./IndexLhu.vue?vue&type=style&index=0&id=9f349848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f349848",
  null
  
)

export default component.exports